var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgComplexityModerateIcon = function SvgComplexityModerateIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 60,
    viewBox: "0 0 75 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Moderado_OFF",
    "data-name": "Moderado OFF",
    transform: "translate(17.41 12.51)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Moderado_OFF-2",
    "data-name": "Moderado OFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5893",
    "data-name": "Grupo 5893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4445",
    "data-name": "Caminho 4445",
    d: "M4.508,34.581c2.58,10.029,9,12.4,14.478,12.4h0c.2,0,.4,0,.6-.009s.4.009.6.009c5.485,0,11.908-2.373,14.485-12.4,1.181-.125,3.355-1,4.26-5.532.467-2.335.256-4.066-.631-5.146a3.033,3.033,0,0,0-2.344-1.1,36.778,36.778,0,0,0-.735-11.889C33.766,5.276,29.829-.113,19.493,0,8.79.121,5.628,5.4,3.792,10.683,2.378,14.744,2.876,20.4,3.18,22.8A3.024,3.024,0,0,0,.872,23.9c-.886,1.08-1.1,2.811-.631,5.146.907,4.539,3.085,5.41,4.266,5.532M37.135,28.69c-.5,2.495-1.355,3.467-2.011,3.841a43.163,43.163,0,0,0,.668-6.331q.056-.791.088-1.559l.077,0a1.2,1.2,0,0,1,.928.43c.505.617.594,1.9.25,3.622M32.4,34.566c-1.955,6.987-6.233,10.416-12.773,10.2h-.071c-.189.006-.379.009-.566.009h0c-6.22,0-10.3-3.424-12.2-10.209q-.126-.449-.239-.918c-.071-.3-.141-.607-.205-.919a40.581,40.581,0,0,1-.753-6.685c0-.015,0-.03,0-.045.026-.434.054-.888.086-1.356.021-.3.043-.608.068-.919s.047-.61.073-.919c.13-1.556.3-3.15.508-4.543a12.429,12.429,0,0,1,3.445-7.121s.026,2.7,4.217,3.732a19.76,19.76,0,0,1-.76-3.85c.082.529.758,2.837,6.331,3.85-.69-1.033-1.059-4.191-1.059-4.191s.484,3.216,6.457,4.249c-.747-.862-1.633-4.249-1.633-4.249s3.872,4.364,7.892,4.938a10.443,10.443,0,0,1-1.824-3.454A9.888,9.888,0,0,1,32.7,17.344c.26,1.282.591,3.409.889,5.462.039.269.076.537.115.8l0,.116c-.007.3-.013.607-.027.919-.021.473-.047.953-.082,1.44a40.284,40.284,0,0,1-.749,6.646q-.095.468-.2.919c-.077.313-.155.618-.24.918m-30.1-9.5a1.213,1.213,0,0,1,.952-.43l.053,0c.022.5.049,1.009.086,1.523a43.5,43.5,0,0,0,.674,6.37c-.658-.373-1.515-1.344-2.016-3.844-.344-1.72-.254-3.005.25-3.622",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4446",
    "data-name": "Caminho 4446",
    d: "M18.568,36.035c.027-1.229-.562-1.88-1.678-1.849-1.116-.03-1.706.62-1.679,1.849-.027,1.228.562,1.879,1.679,1.848,1.115.031,1.705-.619,1.678-1.848",
    transform: "translate(-4.013 -9.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4447",
    "data-name": "Caminho 4447",
    d: "M35.122,34.186c-1.116-.03-1.705.62-1.678,1.849-.027,1.229.562,1.879,1.678,1.847,1.116.03,1.705-.618,1.678-1.847.027-1.229-.562-1.88-1.678-1.849",
    transform: "translate(-8.822 -9.018)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4448",
    "data-name": "Caminho 4448",
    d: "M24.656,46.483l.222.112a1.623,1.623,0,0,0,.207.085,2.9,2.9,0,0,0,1.809,0,1.645,1.645,0,0,0,.208-.085l.222-.112c.611-.309.495-.561-.261-.561H24.917c-.756,0-.872.252-.261.561",
    transform: "translate(-6.401 -12.114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4450",
    "data-name": "Caminho 4450",
    d: "M19.7,29.45a.552.552,0,0,0-.552-.551H14.555a.551.551,0,0,0,0,1.1h4.594a.552.552,0,0,0,.552-.551",
    transform: "translate(-3.694 -7.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_3",
    "data-name": "Uni\\xE3o 3",
    d: "M17751.234,3826.9a.624.624,0,0,1-.646-.6.484.484,0,0,1,.012-.106.491.491,0,0,1-.012-.107.623.623,0,0,1,.646-.6h7.377a.623.623,0,0,1,.645.6.49.49,0,0,1-.01.107.483.483,0,0,1,.01.106.623.623,0,0,1-.645.6Z",
    transform: "translate(-17735.334 -3788.215)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4451",
    "data-name": "Caminho 4451",
    d: "M36.621,28.9H32.027a.551.551,0,0,0,0,1.1h4.594a.551.551,0,1,0,0-1.1",
    transform: "translate(-8.303 -7.623)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1985",
    "data-name": "Ret\\xE2ngulo 1985",
    width: 75,
    height: 60,
    transform: "translate(-17.41 -12.51)",
    fill: "none"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgComplexityModerateIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/complexity-moderate-icon.b9fcd949.svg";
export { ForwardRef as ReactComponent };